// Black
export const PRIMARY_BLACK = "rgba(17, 24, 39, 1)";

// Grey colors
export const PRIMARY_GREY = "rgba(243, 245, 248, 1)"; // Light grey
export const SECONDARY_GREY = "rgba(228, 231, 236, 1)";
export const MID_GREY = "rgba(174, 179, 187, 1)";
export const TERTIARY_GREY = "rgba(74, 84, 102, 1)";
export const QUATERNARY_GREY = "rgba(49, 57, 74, 1)"; // Dark grey

// Brand
export const PRIMARY_BLUE = "rgba(50, 101, 234, 1)";
export const BLUE_LIGHT = "rgba(229, 235, 253, 1)";
export const OLD_BLUE = "rgba(20, 83, 245, 1)"; // We need to check with UI/UX if they want to switch all blue over.
export const BACKGROUND_LIGHT = "rgba(255, 255, 255, 1)";
export const LIGHT_BACKGROUND = "rgba(250, 250, 251, 1)";

// Error flow colors
export const ERROR_COLOR = "rgba(135, 37, 37, 1)";
export const ERROR_DARK = "rgba(63, 7, 7, 1)";
export const ERROR_LIGHT = "rgba(135, 37, 37, 0.16)";
export const SUCCESS_DARK_BACKGROUND = PRIMARY_BLACK;
export const SUCCESS_GREEN = "rgba(1, 124, 63, 1)"; // Text color for success states
export const SUCCESS_LIGHT_BACKGROUND = "rgba(219, 248, 231, 1)"; // Light green background
export const DELETE = "rgba(185, 60, 60, 1)";
export const DELETE_PRESSED = "rgba(158, 53, 53, 1)";
export const YELLOW_ALERT = "rgba(242, 199, 72, 1)";

// Buttons colors
export const BUTTON_PRIMARY = PRIMARY_BLUE;
export const BUTTON_PRIMARY_BORDER = "rgba(0, 92, 214, 1)";
export const BUTTON_BOX_SHADOW = "rgba(255, 255, 255, 0.2)";
export const GHOST_BACKGROUND = BLUE_LIGHT;
export const GHOST_BACKGROUND_PRESSED = "rgba(221, 227, 245, 1)";
export const DISABLED_BACKGROUND = "rgba(20, 83, 245, 0.18)";
export const DISABLED_COLOR = "rgba(160, 164, 173, 1)";
export const DISABLED_SECONDARY = "rgba(98, 111, 134, 1)";

// Fonts colors
export const HEADING = PRIMARY_BLACK;
export const LIGHT_FONT = "rgba(255, 255, 255, 1)";
export const PRIMARY_FONT = QUATERNARY_GREY;
export const SECONDARY_FONT = TERTIARY_GREY;
